import { render, staticRenderFns } from "./SettingsPrograms.vue?vue&type=template&id=050af478&scoped=true&"
import script from "./SettingsPrograms.vue?vue&type=script&lang=js&"
export * from "./SettingsPrograms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050af478",
  null
  
)

export default component.exports